import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    viewBox: "0 0 24 24",
    width: "16",
    height: "16"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("g", {
    xmlns: "http://www.w3.org/2000/svg",
    transform: "matrix(1, 0, 0, 1, 27.009001, -39.238998)"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        fill: "#4285F4",
        d: "M -3.264 51.509 C -3.264 50.719 -3.334 49.969 -3.454 49.239 L -14.754 49.239 L -14.754 53.749 L -8.284 53.749 C -8.574 55.229 -9.424 56.479 -10.684 57.329 L -10.684 60.329 L -6.824 60.329 C -4.564 58.239 -3.264 55.159 -3.264 51.509 Z"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        fill: "#34A853",
        d: "M -14.754 63.239 C -11.514 63.239 -8.804 62.159 -6.824 60.329 L -10.684 57.329 C -11.764 58.049 -13.134 58.489 -14.754 58.489 C -17.884 58.489 -20.534 56.379 -21.484 53.529 L -25.464 53.529 L -25.464 56.619 C -23.494 60.539 -19.444 63.239 -14.754 63.239 Z"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        fill: "#FBBC05",
        d: "M -21.484 53.529 C -21.734 52.809 -21.864 52.039 -21.864 51.239 C -21.864 50.439 -21.724 49.669 -21.484 48.949 L -21.484 45.859 L -25.464 45.859 C -26.284 47.479 -26.754 49.299 -26.754 51.239 C -26.754 53.179 -26.284 54.999 -25.464 56.619 L -21.484 53.529 Z"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        fill: "#EA4335",
        d: "M -14.754 43.989 C -12.984 43.989 -11.404 44.599 -10.154 45.789 L -6.734 42.369 C -8.804 40.429 -11.514 39.239 -14.754 39.239 C -19.444 39.239 -23.494 41.939 -25.464 45.859 L -21.484 48.949 C -20.534 46.099 -17.884 43.989 -14.754 43.989 Z"
    })
], -1);
const _hoisted_3 = [
    _hoisted_2
];
import { ButtonVariant, OrButtonV3 as OrButton } from '@onereach/ui-components';
import config from '../../config';
export default /*#__PURE__*/ _defineComponent({
    __name: 'GoogleLogin',
    props: {
        loading: { type: Boolean },
        verificationCode: { default: '' },
        label: { default: '' },
        showIcon: { type: Boolean, default: true },
        buttonType: { default: ButtonVariant.Outlined }
    },
    setup(__props) {
        const props = __props;
        const openSSOIframe = () => {
            let url = `${config.GLOBAL_SSO_URL}?GATEWAY_URL=${config.GATEWAY_URL}&AUTH_UI_URL=${config.AUTH_UI_URL}&PROVIDERS_ACCOUNT_ID=${config.PROVIDERS_ACCOUNT_ID}&SDK_API_URL=${config.SDK_API_URL}`;
            if (props.verificationCode)
                url += `&MFACode=${props.verificationCode}`;
            const left = Math.max(window.innerWidth / 2 - 300, 0);
            const top = Math.max(window.innerHeight / 2 - 300, 0);
            window.open(url, 'SSO', `width=590,height=600,left=${left},top=${top}`);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(OrButton), {
                color: "primary",
                variant: _ctx.buttonType,
                loading: _ctx.loading,
                onClick: openSSOIframe
            }, {
                default: _withCtx(() => [
                    (_ctx.showIcon)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
                        : _createCommentVNode("", true),
                    _createTextVNode("   " + _toDisplayString(_ctx.label || _ctx.$t('login.password_restore.Sign in')), 1)
                ]),
                _: 1
            }, 8, ["variant", "loading"]));
        };
    }
});
